export const isAccountInputDisabled = (canSubmit: boolean, isSubmitLoading: boolean, canEditCurrentWeek: boolean) =>
  !canSubmit || isSubmitLoading || !canEditCurrentWeek
